<template>
    <div class='buy-domain'>
        <script type="application/javascript" defer src="/internacional/public/scripts/front-encryption/encrypt.js"></script>
        <script type="application/javascript" defer src="/internacional/public/office2/js/domain-register-dashboard.js"></script>
        <script type="application/javascript" defer src="/internacional/public/office2/js/domain-register-api-requests.js"></script>
        <script type="application/javascript" defer src="/internacional/public/scripts/geral/domain-register-countries-list.js"></script>
        <script type="application/javascript" defer src="/internacional/public/scripts/geral/domain-register-countries-phone-cc-list.js"></script>

        <div class="first__step js-first__step">
            <a class="btn__buy__domain js-button-buy__domain" :href="rota_old_tool" target="_blank">{{ this.view.translation.buy_domain.label_buy_domain /*.replace(`${this.view.translation.buy_domain.label_ext_buy}`, '$')*/ }}</a>
        </div>
    </div>
</template>

<script>

export default {
    name: "dv5-buy-domain",
    props: {
        view: {
            type: Object,
        }
    },
    data() {
        return {
            encryption_key: this.view.encryption_key,
            rota_old_tool: this.view.rota_old_tool,
            buyDomainTranslations: {
                label_invalid_pswd : this.view.translation.buy_domain.label_invalid_pswd,
                label_error_invalid_email : this.view.translation.buy_domain.label_error_invalid_email,
                name_required : this.view.translation.buy_domain.name_required,
                phone_required : this.view.translation.buy_domain.phone_required,
                phone_cc_required : this.view.translation.buy_domain.phone_cc_required,
                name_min: this.view.translation.buy_domain.name_min,
                phone_min: this.view.translation.buy_domain.phone_min,
                phone_only_numbers: this.view.translation.buy_domain.phone_only_numbers,
                label_bd_accept_terms_of_use : this.view.translation.buy_domain.label_bd_accept_terms_of_use,
                country_required : this.view.translation.buy_domain.country_required,
                state_required : this.view.translation.buy_domain.state_required,
                city_required : this.view.translation.buy_domain.city_required,
                zipcode_required : this.view.translation.buy_domain.zipcode_required,
                address_required : this.view.translation.buy_domain.address_required,
                zipcode_invalid : this.view.translation.buy_domain.zipcode_invalid,
                for_one_year: this.view.translation.buy_domain.for_one_year,
            }
        };
    },

    created() {
    },

    mounted() {
    },

    methods: {
    },

    computed: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../../scss/extras/_variables';
.buy-domain {
    width: 140px;
    height: 40px;
    max-width: 140px;

    background: #FFFFFF;
    border-radius: 4px;

    .first__step {
        height: 100%;
        display: flex;
        .btn__buy__domain {
            border-radius: 6px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $dv5-color9;
            color: $dv5-color4;

            font-size: 13px;
            font-weight: 900;
            text-align: center;
            padding: 4px;
            font-family: $dv5-font1;
            text-transform: uppercase;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/buy-domain/BuyDomain.vue